function initSlider(){
    const BSbreakpoints = {
        xxl: 1400,
        xl: 1200,
        lg: 992,
        md: 768,
        sm: 480
    };

    if ($('.page-hero').children().length > 1) {
        $('.page-hero').slick({
            slidesToShow: 1,
            infinite: true,
            speed: 600,
            autoplay: false,
            autoplaySpeed: 10000,
            arrows: true,
            dots: true,
            fade: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false
        });
    }

    if ($('.teaser-slider').children().length > 1) {
        $('.teaser-slider').each(function (e) {
            let data = $(this).data();

            $(this).slick({
                slidesToShow: data.slidesXxl,
                infinite: true,
                speed: 600,
                autoplay: false,
                arrows: true,
                dots: true,
                fade: false,
                pauseOnFocus: true,
                pauseOnHover: true,
                pauseOnDotsHover: true,
                responsive: [
                    {
                        breakpoint: BSbreakpoints.xl,
                        settings: {
                            slidesToShow: data.slidesXl,
                        }
                    },
                    {
                        breakpoint: BSbreakpoints.lg,
                        settings: {
                            slidesToShow: data.slidesLg,
                        }
                    },
                    {
                        breakpoint: BSbreakpoints.md,
                        settings: {
                            slidesToShow: data.slidesMd,
                        }
                    },
                    {
                        breakpoint: BSbreakpoints.sm,
                        settings: {
                            slidesToShow: data.slides,
                        }
                    },
                ]
            });
        });
    }

    var breakpoints = {
        xxl: {
            items: 10,
        },
        xl: {
            items: 8,
            width: BSbreakpoints.xxl,
        },
        lg: {
            items: 6,
            width: BSbreakpoints.xl,
        },
        md: {
            items: 5,
            width: BSbreakpoints.lg,
        },
        sm: {
            items: 3,
            width: BSbreakpoints.md,
        },
        xs: {
            items: 2,
            width: BSbreakpoints.sm,
        }
    };

    $('.logo-parade-slider').each(function() {
        var slider = $(this);
        var slideritems = slider.children().length;
        var options = {
            arrows: false,
            dots: false,
            infinite: false,
            speed: 350,
            slidesToShow: 10,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4500,
            pauseOnHover: true,
            responsive: []
        };

        Object.keys(breakpoints).forEach(function(key) {
            let infinite = (slideritems > breakpoints[key].items);
            if (key === 'xxl') {
                options.slidesToShow = breakpoints[key].items;
                options.infinite = infinite;
            } else {
                options.responsive.push({
                    breakpoint: breakpoints[key].width,
                    settings: {
                        slidesToShow: breakpoints[key].items,
                        infinite: infinite,
                    }
                });
            }
        });

        $(this).slick(options);
    });

    let bannerSlider =  $('.ce-banner-slider');
    if (bannerSlider.children().length > 1) {
        bannerSlider.slick({
            infinite: true,
            speed: 400,
            slidesToShow: 1,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnHover: true
        });
    }
}
